import { useOverlays } from "contexts/OverlayContext";
import { pluralize } from "@common/helpers/string";
import { useDeleteCustomCategoryMutation } from "@api/category.api";
import { Category } from "@common/types/category";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface Props {
    category: Category;
    label: string;
    transactionsCount: number;
    onClose: () => void;
    show: boolean;
}

const DeleteCategoryModal = ({
    category,
    label,
    transactionsCount,
    onClose,
    show,
}: Props) => {
    const deleteCategory = useDeleteCustomCategoryMutation(category);

    return (
        <ConfirmationModal
            show={show}
            onHide={onClose}
            title={`Are you sure that you want to delete subcategory: ${label}?`}
            question={
                transactionsCount > 0
                    ? `This category has ${transactionsCount} ${pluralize("transaction", transactionsCount)} associated with it.`
                    : ""
            }
            no="Cancel"
            onReject={onClose}
            onConfirmMutation={deleteCategory}
            yes="Delete"
        />
    );
};

export const DeleteCategoryModalContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("deleteCategory");

    if (!overlayInfo?.data) {
        return null;
    }

    const { category, label, transactionsCount } = overlayInfo.data;

    return (
        <DeleteCategoryModal
            category={category}
            label={label}
            transactionsCount={transactionsCount}
            onClose={closeOverlay}
            show={!overlayIsClosing}
        />
    );
};
